







export default {
  name: 'GraphUpIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
